import { render } from "./TgSubmit.vue?vue&type=template&id=05dc3ef6"
import script from "./TgSubmit.vue?vue&type=script&lang=js"
export * from "./TgSubmit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__